import { normalizeRole } from './permissions';

export function canManageClientPortalAdmin(role?: string | null): boolean {
  return normalizeRole(role) === 'ADMIN';
}

export function canManageClientPortalSales(_email?: string | null, role?: string | null): boolean {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === 'VENTAS_INTERNAS' || normalizedRole === 'ADMIN';
}

export function canManageClientPortalBilling(_email?: string | null, role?: string | null): boolean {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === 'COBRANZA' || normalizedRole === 'ADMIN';
}
